export enum RadarDetectionDependencyConnectionType {
  HTTP = 'HTTP',
  GRPC = 'GRPC',
  RABBIT_MQ = 'RABBIT_MQ',
}
